import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function LoadingContent({ testId, iconStyle }) {
  return (
    // this Box takes up the entire space and renders a circular loading indicator in the center
    <Box 
        data-testid = "loading-icon"
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
        }}
    >
      <CircularProgress
        data-testid={testId}
        color={iconStyle?.color || "primary"}
        sx={{
          ...iconStyle,
        }}
      />
    </Box>
  );
}